import BasicDomain from "./BasicDomain";
import * as yup from 'yup';

export default class Person extends BasicDomain {
    static DEFAULTS = {
        firstName: '',
        lastName: '',
        email: '',
        deceased: false
    }

    static VALIDATION_SCHEMA = yup.object({
        firstName: yup.string().required('First name is required'),
        lastName: yup.string().required('Last name is required')
    }).required();

    constructor(props) {
        super('Person', props, Person.DEFAULTS);
    }

    get name () {
        return `${this.firstName} ${this.lastName}`;
    }

    getByPath = (path = []) => {
        let value = this;
        try {
            for (const key of path) {
                if (!value) return null;
                let newValue
                if (typeof value.get === 'function') {
                    newValue = value?.get(key);
                } else {
                    newValue = value[key];
                }
                value = newValue;
                if (value instanceof Date) {
                    return CommonUtils.formatDate(value, this.get('dateSpecificity'));
                }
            }
            return value;
        } catch (err) {
            console.error('Error getting value by path', path, err, value);
            return null;
        }
    }
}

if (global.Parse.Object.registerSubclass) {
    global.Parse.Object.registerSubclass('Person', Person);
}
